import { computed, ref } from 'vue';
import { findInArray } from '@/lib/array';

export default function useSpaces(spaceProperties, search, userLang) {
  const allSpaces = spaceProperties.value[0].options;

  const isMatch = (node, searchTerm) => node.label[userLang].toLowerCase().includes(searchTerm.toLowerCase());
  const hasMatch = (res, node) => node.match || res || node.children.reduce(hasMatch, false);

  const treeBuilder = (spaces) => {
    const mapChildMatches = (node) => ({
      ...node,
      containsMatch: node.children.reduce(hasMatch, false),
      children: node.children.map(mapChildMatches),
    });

    const mapChildren = (level, parentCollapsed) => (c) => {
      const node = findInArray({ haystack: spaces, needle: c.uid });
      if (node === null) {
        return c;
      }

      const children = spaces.filter((s) => s.parents.filter((p) => p.uid === node.uid).length > 0);
      const collapsed = collapsedNodes.value.includes(node.uid);
      return {
        ...node,
        match: isMatch(node, search.value),
        children: children.map(mapChildren(level + 1, collapsed || parentCollapsed)),
        collapsed,
        parentCollapsed,
        level,
      };
    };
    return spaces.filter((o) => o.parents.length === 0)
      .map(mapChildren(0, false))
      .map(mapChildMatches);
  };

  const collapsedNodes = ref([]);
  const toggleCollapse = (uid) => {
    if (collapsedNodes.value.includes(uid)) {
      collapsedNodes.value = collapsedNodes.value.filter((e) => e !== uid);
      return;
    }
    collapsedNodes.value.push(uid);
  };

  const depthFirstOrder = (res, node) => [...res, node, ...node.children.reduce(depthFirstOrder, [])];
  const tree = computed(() => treeBuilder(allSpaces));
  const normalizedSpaces = computed(() => applyMappers().reduce(depthFirstOrder, []));

  const mappers = ref([]);
  const setSpaceMappers = (array) => {
    mappers.value = array;
  };

  const applyMappers = () => {
    let spaces = tree.value;
    mappers.value.forEach((mapper) => {
      spaces = spaces.map(mapper);
    });
    return spaces;
  };

  const filteredSpaces = computed(() => normalizedSpaces.value.filter((s) => s.match === true));

  return {
    normalizedSpaces,
    filteredSpaces,
    setSpaceMappers,
    toggleCollapse,
  };
}
